export default {
  SET_user(state, payload) {
    state.user = payload
  },

  SET_token(state, payload) {
    state.token = payload
  },

  SET_success_message(state, payload) {
    state.successMessage = payload
  },

  SET_error_message(state, payload) {
    state.errorMessage = payload
  },

  SET_process(state, payload) {
    state.process = payload
  },

  SET_email(state, payload) {
    state.email = payload
  },

  SET_password(state, payload) {
    state.password = payload
  },

  SET_DialodPermissionDenied(state, payload) {
    state.DialodPermissionDenied = payload
  },
}
